import { View } from "react-native";
import { useCustomTheme } from "../hooks/useCustomTheme";
export const ThemedView = ({ style, ...rest }) => {
    const { colors } = useCustomTheme();
    return (<View style={[{ backgroundColor: colors.background }, style]} {...rest}/>);
};
//# sourceMappingURL=ThemedView.js.map